/**
 * IE11 NodeList returned from document.querySelectorAll does not support
 * forEach by default. This polyfill adds the missing function from the
 * prototype of the Array
 * Official Info: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Browser_Compatibility
 */

/* eslint-disable */
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        let el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
/* eslint-enable */
